// extracted by mini-css-extract-plugin
module.exports = {"title":"AdminLayout_title__2amI0","logo":"AdminLayout_logo__2zgA6","user":"AdminLayout_user__24yhw","header":"AdminLayout_header__3P_n8","page":"AdminLayout_page__23YNe"};